module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "position": "fixed",
      "z-index": "999",
      "bottom": "0",
      "text-align": "end",
      "width": "60px"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "fab": "",
      "dark": "",
      "medium": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.generateCsv()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n        download\n      ")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-392db7ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/DownloadData.vue
// module id = 1711
// module chunks = 0